import { hasWindow } from "@omni/utils/dom.utils";

import {
    PureAemComponent,
    registerComponent
} from "@/components/pureAemComponent";

const infoSubNavHeight = 40;

class AnchorScrollSpy extends PureAemComponent {
    spyElement: HTMLElement | null = null;
    spyBlockElement: HTMLElement | null = null;

    constructor(element: HTMLElement) {
        super(element);
        const ref = this.element.getAttribute("href");
        if (ref) {
            this.spyElement = document.querySelector(`${ref}`);
            this.spyBlockElement = this.findAncestor(
                this.spyElement,
                ".js-anchor-scroll-spy__block"
            );
            this.init();
        }
    }

    init() {
        this.bindEventListeners();
    }

    /**
     * Bind the events to their handlers
     */
    bindEventListeners() {
        window.document.addEventListener(
            "scroll",
            this.scrollHandler.bind(this)
        );
    }

    /**
     * When the page is being scrolled check which anchor is active
     * - Check if the anchor element is at the top or above and if the content block is below the top
     */
    scrollHandler() {
        if (this.spyElement && this.spyBlockElement) {
            if (
                this.spyElement.getBoundingClientRect().top <= 2 &&
                this.spyBlockElement.getBoundingClientRect().bottom >=
                    this.getOffset()
            ) {
                this.element.classList.add(
                    "nav-link--active",
                    "tw:border-b-primary!"
                );
            } else {
                this.element.classList.remove(
                    "nav-link--active",
                    "tw:border-b-primary!"
                );
            }
        }
    }

    /**
     * Get the calculated offset of the headerHeight with the PDP sub nav block and padding of 15px
     * @returns {number}
     */
    getOffset() {
        return infoSubNavHeight + 20;
    }

    /**
     * Find the ancestor of a given element
     * @param el
     * @param sel
     * @returns {HTMLElement}
     */
    findAncestor(el: any, sel: string) {
        if (el) {
            while (
                // biome-ignore lint/suspicious/noAssignInExpressions: <TODO>
                (el = el.parentElement) &&
                !(el.matches || el.matchesSelector).call(el, sel)
            );
            return el;
        } else {
            return null;
        }
    }
}

const InitAnchorScrollSpy = () => {
    hasWindow() && registerComponent(".js-anchor-scroll-spy", AnchorScrollSpy);
};

export { InitAnchorScrollSpy };
